import useCollection from 'core/hooks/useCollection'

const useNotes = ({ personId, caseId }) => {
  return useCollection('notes', { personId, caseId })
}
export default useNotes
